import React from "react";
import "./ProcessAndTimelineTab.css";
import ProcessSteps from "../../Shared/ProcessSteps/ProcessSteps";
import { TextWithLineBreaks } from "../../../Components/TextWithLineBreaks";

const timelineSteps = [
  {
    title: "상담 및 견적",
    details: [
      {
        items: ["출판 목적, 도서 내용, 저자 요청사항 확인", "맞춤형 견적 제안"],
      },
    ],
  },
  {
    title: "번역 및 원고 정리",
    details: [
      {
        items: [
          "영어 번역(또는 교정,영문 원고인 경우 생략 가능)",
          "메타데이터 초안 작성",
        ],
      },
    ],
  },
  {
    title: "편집 및 포맷팅",
    details: [
      {
        items: [
          "전자책(ePub), 종이책(POD) 편집 & 표지 디자인",
          "(판형 종류 선택 포함)",
        ],
      },
    ],
  },
  {
    title: "검토 및 수정",
    details: [
      {
        items: ["저자 피드백 기반 1회 일괄 수정 제공"],
      },
    ],
  },
  {
    title: "KDP 업로드 및 등록",
    details: [
      {
        items: [
          "아마존 KDP 업로드",
          "(업로드 후, 약 72시간 내 판매 가능 상태 전환)",
        ],
      },
    ],
  },
  {
    title: "저자관리, 마케팅 지원",
    details: [
      {
        items: ["저자 페이지 생성, 아마존 마케팅 지원"],
      },
    ],
  },
];

function ProcessAndTimelineTab({}) {
  return (
    <div className="process-and-timeline-tab">
      <h1 className="process-and-timeline-tab-title">
        서비스 과정 및 진행일정
      </h1>

      <div className="steps-wrapper">
        <ProcessSteps steps={timelineSteps} />
      </div>
    </div>
  );
}

export default ProcessAndTimelineTab;
